export default __webpack_public_path__ + "static/media/grafema_SET_14.a3ed39ba.jpg";